// React
import React from 'react';
import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.in';
import { Button, Modal, ModalHeader, Label, Col, Input } from 'reactstrap';

// Containers Injections
import { InputPhone } from '../../../../../../containers/componentsInjection';

export const ModalVisitSchedule = ({
  id,
  isOpen,
  toggle,
  validation,
  handleBack,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>
        {id ? 'Editar Agendamento' : 'Novo Agendamento'}
      </ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="visitDateInput" className="form-label">
                Data da Visita
              </Label>
              <Input
                type="date"
                id="visitDateInput"
                value={validation.values.visitDateInput}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                invalid={
                  !!(
                    validation.touched.visitDateInput &&
                    validation.errors.visitDateInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="contactInput" className="form-label">
                Contato
              </Label>
              <Input
                type="text"
                id="contactInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.contactInput || ''}
                invalid={
                  !!(
                    validation.touched.contactInput &&
                    validation.errors.contactInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="telInput" className="form-label">
                Telefone 1
              </Label>
              <InputPhone
                id="telInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.telInput || ''}
              />
              {validation.touched.telInput && validation.errors.telInput ? (
                <p className="labelErrorValidation">
                  {validation.errors.telInput}
                </p>
              ) : null}
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="telInput2" className="form-label">
                Telefone 2
              </Label>
              <InputPhone
                id="telInput2"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.telInput2 || ''}
              />
            </div>
          </Col>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                handleBack();
                validation.resetForm();
              }}
            >
              Cancelar
            </button>
            <Button color="primary" type="submit">
              Agendar
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
